export default function groupPrePedidoItens(itens) {
  const grouped = {};
  (itens || []).forEach((item) => {
    const cat = (item.Categoria || item.categoria || "Outros").trim() || "Outros";
    const sub = (item.Subcategoria || item.subcategoria || "Produtos").trim() || "Produtos";
    if (!grouped[cat]) grouped[cat] = {};
    if (!grouped[cat][sub]) grouped[cat][sub] = [];
    grouped[cat][sub].push(item);
  });
  return grouped;
}
